// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__rwGUO","content":"Banner_content__J0uHM","title":"Banner_title__qAKoh","text":"Banner_text__x8Nm2"};